module.exports = __webpack_public_path__ + "img/ch_gallery_4.8c322512.jpg";